import './transporterStakeholderSelection.css';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import TrashIcon from '../../../images/TrashIcon.png';
import { getAllRoutes, getAllTransporterName, getFromToTransporterDropdown, submitStakeHolderMapping } from './transportermappingApi';
import 'bootstrap/dist/css/bootstrap.min.css';
import { titleCase } from '../../../common/commonFunction';
import { DialogContent, Dialog, DialogActions, Button } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Card, CardContent, Container, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { validation_check_mapping } from '../stakeHolderMapping/stakeholderMappingApi';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';

function SelectTransporterStakeholder() {
  const navigate = useNavigate()
  const [details, setDetails] = useState({
    transsourceState: '',
    transsourceDistrict: '',
    transMappingRoute: '',
    selectedTransporterName: '',
    selectedTransporterUrn: '',
    transMapFrom: '',
    transMapTo: '',
    transMapFromName: '',
    transMapFromType: '',
    transMapFromUrn: '',
    transMapToName: '',
    transMapToType: '',
    transMapToUrn: '',

  });
  const [errorMessage, setErrorMessage] = useState({
    chooseRouteError: '',
    chooseTransportertError: '',
    chooseFromError: '',
    chooseToError: ''
  });
  const [transporterDetails, settransporterDetails] = useState([]);
  const [routerDetails, setRouterDetails] = useState([]);
  const [fromDropdownTransporter, setFromDropdownTransporter] = useState([]);
  const [toDropdownTransporter, setToDropdownTransporter] = useState([]);
  const [saveMappingData, setSaveMappingData] = useState();
  let [multipleMappingDetails, setMultipleMappingDetails] = useState([]);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [logConfirmModalOpenSubmit, setLogConfirmModalOpenSubmit] = useState(false);
  const handleConfirmLogModalOpenSubmit = () => setLogConfirmModalOpenSubmit(true);
  const handleConfirmLogModalCloseSubmit = () => setLogConfirmModalOpenSubmit(false);
  const [mappingValidationCheck, setMappingValidationCheck] = useState([]);
  const [finaldata, setFinalData] = useState();
  const [validationlogOpen, setValidationlogOpen] = useState(false);
  const handleValidationModalOpen = () => setValidationlogOpen(true);
  const handleValidationModalClose = () => setValidationlogOpen(false);
  const [failedMappingArr, setFailedMappingArr] = useState();
  const [lastElement, setLastElement] = useState();
  const [successMappingArr, setSuccessMappingArr] = useState();
  const [deleteIndex, setDeleteIndex] = useState();
  const [submit, setSubmit] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const statelog = useRef(true);
  const routelog = useRef(true);
  useEffect(() => {
    if (routelog.current) {
      routelog.current = false;
      getAllRoutes(setRouterDetails)

    }
  }, [routelog]);
  useEffect(() => {
    if (statelog.current) {
      statelog.current = false;
      getAllTransporterName(settransporterDetails)
    }
  }, [statelog]);
  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value })
    if (e.target.name === "transMappingRoute") {
      (details.transMapToUrn.length > 0) && (details.transMapFromUrn.length > 0) && (details.selectedTransporterUrn.length > 0) ?
        setDetails({
          ...details,
          selectedTransporterName: '', selectedTransporterUrn: '', transMapFromType: '', transMapFromUrn: '', transMapFromName: '', transMapToType: '', transMapToUrn: '', transMapToName: '', [e.target.name]: e.target.value
        })
        :
        (details.selectedTransporterUrn.length > 0) && (details.transMapFromUrn.length > 0) ?
          setDetails({
            ...details,
            selectedTransporterName: '', selectedTransporterUrn: '', transMapFromType: '', transMapFromUrn: '', transMapFromName: '', [e.target.name]: e.target.value
          })
          :
          setDetails({
            ...details,
            selectedTransporterName: '', selectedTransporterUrn: '', [e.target.name]: e.target.value
          })
      setErrorMessage({ ...errorMessage, chooseRouteError: " " });
    }
    if (e.target.name === "selectedTransporterName") {
      let result_transdetails = e.target.value.split("*")
      setDetails({ ...details, selectedTransporterName: result_transdetails[1], selectedTransporterUrn: result_transdetails[0] })
      getFromToTransporterDropdown(result_transdetails[0], '', setFromDropdownTransporter, setToDropdownTransporter, details)
      setErrorMessage({ ...errorMessage, chooseTransportertError: " " });
    }
    if (e.target.name === "transMapFrom") {
      let result_from = e.target.value.split("&")
      setDetails({ ...details, transMapFromType: result_from[1], transMapFromUrn: result_from[0], transMapFromName: result_from[2] })
      getFromToTransporterDropdown(details.selectedTransporterUrn, result_from[0], setFromDropdownTransporter, setToDropdownTransporter, details)
      setErrorMessage({ ...errorMessage, chooseFromError: " " });
    }
    if (e.target.name === "transMapTo") {
      let result_to = e.target.value.split("#")
      setDetails({ ...details, transMapToType: result_to[1], transMapToUrn: result_to[0], transMapToName: result_to[2] })
      setErrorMessage({ ...errorMessage, chooseToError: " " });
    }
  }
  const onSubmitStakeholder = (e) => {
    e.preventDefault();
    handleConfirmLogModalOpenSubmit();
    setFailedMappingArr();
    setSuccessMappingArr();
    // submitStakeHolderMapping(multipleMappingDetails, setSaveMappingData)
  }
  useEffect(() => {
    if (mappingValidationCheck.length > 0) {
      const failTempArr = [];
      const successTempArr = [];
      mappingValidationCheck?.map((item) => {
        if (item?.validationStatus?.status === "FAILURE") {
          const pushObject = multipleMappingDetails.find(findItem => ((findItem?.sourceStakeholderUrn === item?.mapping?.sourceStakeholderUrn) && (findItem?.targetStakeholderUrn === item?.mapping?.targetStakeholderUrn)&& (findItem?.mapping === 'add')));
          failTempArr.push(pushObject);
        }
        if (mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {
          const pushObject = multipleMappingDetails.find(findItem => ((findItem?.sourceStakeholderUrn === item?.mapping?.sourceStakeholderUrn) && (findItem?.targetStakeholderUrn === item?.mapping?.targetStakeholderUrn) && (findItem?.mapping === 'add')));
          successTempArr.push(pushObject);
        }
      });
      setSuccessMappingArr(successTempArr)
      setFailedMappingArr(failTempArr);
      if (!mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {
        toast.error("Mappings Marked In Red Are Pending For Approval")
      }
    }
  }, [multipleMappingDetails, mappingValidationCheck, finaldata]);
  useEffect(() => {
    if (successMappingArr?.length > 0 && mappingValidationCheck) {
      handleValidationModalClose()
      submitStakeHolderMapping(finaldata, setSaveMappingData);
      setSuccessMappingArr()
      setMappingValidationCheck([])
    }
  }, [setSaveMappingData, successMappingArr, mappingValidationCheck, finaldata]);
  function onConfirmCallBackSubmit() {
    handleConfirmLogModalCloseSubmit();
    const finaldetails = multipleMappingDetails?.filter(item => item?.mapping === "add")?.map((({ id, mapping, ...rest }) => rest))
    setFinalData(finaldetails)
    validation_check_mapping(finaldetails, setMappingValidationCheck, true)
  }
  function onCancelBackSubmit() {
    handleConfirmLogModalCloseSubmit();
  }

  const onAddTransMapping = (e) => {
    setSubmit(true)
    setValidationlogOpen(false)
    setMappingValidationCheck([])
    if ((details.transMappingRoute) && (details.transMapFromUrn) && (details.transMapToName) && (details.selectedTransporterUrn)) {
      if (multipleMappingDetails.some(uniqueval => {
        return (uniqueval.mapping !== 'delete' && uniqueval.transporterUrn === details.selectedTransporterUrn && uniqueval.targetStakeholderUrn === details.transMapToUrn && uniqueval.sourceStakeholderUrn === details.transMapFromUrn)
      })) {
       toast.error("Already Added")
      }
      else {
        let rowsArr = [...multipleMappingDetails]
        rowsArr.push(
          {
            id: multipleMappingDetails.length + 1,
            sourceStakeholderType: details.transMapFromType,
            transporterUrn: details.selectedTransporterUrn,
            sourceStakeholderUrn: details.transMapFromUrn,
            sourceStakeholderName: details.transMapFromName,
            targetStakeholderType: details.transMapToType,
            targetStakeholderUrn: details.transMapToUrn,
            targetStakeholderName: details.selectedTransporterName,
            route: details.transMappingRoute,
            transporter: details.selectedTransporterName,
            from: details.transMapFromName,
            to: details.transMapToName,
            mapping: 'add'
          });
        setMultipleMappingDetails(rowsArr);
        setDetails({
          ...details, transsourceState: '',
          transsourceDistrict: '',
          transMapFromType: '',
          transMapToType: '',
          transMapFromUrn: '',
          transMapToUrn: '',
          transMapToName: '',
          transfromName: ''
        });
        setShowGrid(true);
      }
    }
    else {
      if (!details.transMapToUrn) {
        setErrorMessage({ ...errorMessage, chooseToError: "Select To Satkeholder" });
      }
      if (!details.transMapFromUrn) {
        setErrorMessage({ ...errorMessage, chooseFromError: "Select From Satkeholder" });
      }
      if (!details.selectedTransporterUrn) {
        setErrorMessage({ ...errorMessage, chooseTransportertError: "Select Transporter" });
      }
      if (!details.transMappingRoute) {
        setErrorMessage({ ...errorMessage, chooseRouteError: "Select Route" });
      }
    }
  }
  // console.log(multipleMappingDetails)
  const onDeleteMappedDetails = (e, index) => {
    e.preventDefault();
    setDeleteIndex(index);
    setValidationlogOpen(false)
    setMappingValidationCheck([])
    setFailedMappingArr()
    setSuccessMappingArr()
    handleConfirmLogModalOpen();
  };
  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    const rows = [...multipleMappingDetails];
    // var index = rows.map(e => e.id).indexOf(deleteIndex);
    const tempArr = (rows?.map(item => {
      if (item.id === deleteIndex) {
        item.mapping = "delete"
      }
      return item
    }
    ))
    // if (index > -1) {
    //   rows.splice(index, 1);
    // }
    //rows.splice(deleteIndex, 1);
    setMultipleMappingDetails(tempArr);
    // if (multipleMappingDetails.length < 2) {
    //   setShowGrid(false);
    // }
  }

  function onCancelBack() {
    handleConfirmLogModalClose();
  }

  useEffect(() => {
    if (saveMappingData) {
      if(saveMappingData?.status === "SUCCESS") {
        toast.success(saveMappingData?.description)
        navigate('/resourcedashboard/home');
      }
      else toast.error(saveMappingData?.description);
    }
  }, [saveMappingData]);

  const addtransportertmapping = [
    { field: 'route', headerName: 'Route', width: 150 },
    { field: 'transporter', headerName: 'Transporter', width: 150 },
    { field: 'transporterUrn', headerName: 'Transporter URN', width: 180 },
    { field: 'from', headerName: 'Map From', width: 150 },
    { field: 'sourceStakeholderUrn', headerName: 'Source URN', width: 150 },
    { field: 'to', headerName: 'Map To', width: 150 },
    { field: 'targetStakeholderUrn', headerName: 'Targeted URN', width: 150 },
    {
      field: 'deleteaction', headerName: 'Action', width: 120,
      valueGetter: () => {
        return "Delete"
      },
      renderCell: (params) => {
        return (
          <img style={{ cursor: "pointer" }} src={TrashIcon} onClick={(e) => onDeleteMappedDetails(e, params?.row?.id)} />
        )
      }
    },
  ]
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES03</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
            Select Stakeholder Mapping
          </Typography>
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={4}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.transMappingRoute}>
                  <InputLabel id="routemapping-label">Route Mapping</InputLabel>
                  <Select
                    label="Route Mapping"
                    name="transMappingRoute" value={details.transMappingRoute || ''} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Route</em></MenuItem>
                    {
                      routerDetails.map((transrouterdetails) =>
                        <MenuItem value={transrouterdetails}>{transrouterdetails}</MenuItem>)
                    }
                  </Select>
                  <FormHelperText>{errorMessage?.chooseRouteError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.selectedTransporterUrn}>
                  <InputLabel id="selecttransporter-label">Transporter</InputLabel>
                  <Select
                    label="Transporter"
                    name="selectedTransporterName" value={details.selectedTransporterUrn + '*' + details.selectedTransporterName} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Transporter</em></MenuItem>
                    {
                      transporterDetails.map((transdetails) =>
                        <MenuItem value={transdetails.urn + '*' + transdetails.name}>{transdetails.name && titleCase(transdetails.name)} ({transdetails.urn})</MenuItem>)
                    }
                  </Select>
                  <FormHelperText>{errorMessage?.chooseTransportertError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.transMapFromUrn}>
                  <InputLabel id="mapfrom-label">Map From</InputLabel>
                  <Select
                    label='Map From'
                    name="transMapFrom" value={details.transMapFromUrn + '&' + details.transMapFromType + '&' + details.transMapFromName} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>From</em></MenuItem>
                    {
                      fromDropdownTransporter.map((fromdropdown) =>
                        <MenuItem value={fromdropdown.urn + '&' + fromdropdown.type + '&' + fromdropdown.name}>{fromdropdown.name && titleCase(fromdropdown.name)} ({fromdropdown.urn})</MenuItem>)
                    }
                  </Select>
                  <FormHelperText>{errorMessage?.chooseFromError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4} sx={{ mt: 1 }}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.transMapToUrn}>
                  <InputLabel id="mapto-label">Map To</InputLabel>
                  <Select
                    label='Map To'
                    name="transMapTo" value={details.transMapToUrn + '#' + details.transMapToType + '#' + details.transMapToName} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>To</em></MenuItem>
                    {
                      toDropdownTransporter.map((todropdown) =>
                        <MenuItem value={todropdown.urn + '#' + todropdown.type + '#' + todropdown.name}>{todropdown.name && titleCase(todropdown.name)} ({todropdown.urn})</MenuItem>)
                    }
                  </Select>
                  <FormHelperText>{errorMessage?.chooseToError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={1} sx={{ mt: 1 }}>
                <Button sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onAddTransMapping(e)}>Add</Button>
              </Grid>
            </Grid>
            {showGrid &&
              <Grid item xs={12} lg={12}>
                <Box
                  sx={{
                    height: 350, width: '100%', mt: 2,
                    '& .themeSuccess': {
                      backgroundColor: '#FFFFFF'
                    },
                    '& .themeFailure': {
                      backgroundColor: '#FF7F7F',
                      color: '#1a3e72',
                    },
                  }}>
                  <DataGrid
                    rows={multipleMappingDetails.filter(item => item?.mapping === 'add')}
                    columns={addtransportertmapping}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    getRowId={(row) => row?.id}
                    getCellClassName={(params) => {
                      return failedMappingArr?.includes(params?.row) ? 'themeFailure' : 'themeSuccess';
                    }}
                    components={{
                      Toolbar: CustomDataGridToolbar,
                    }}
                    componentsProps={{ toolbar: { rows: multipleMappingDetails, columns: addtransportertmapping, fileName: "TransporterMappingList.xlsx", } }}
                  />
                </Box>
              </Grid>
            }
            <Box display='flex' justifyContent="flex-end">
              {showGrid &&
                <Button sx={{ minWidth: 100, mt: 2 }} variant="contained" onClick={(e) => onSubmitStakeholder(e)}>Submit</Button>
              }
            </Box>
          </CardContent>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} onConfirm={onConfirmCallBack} onClose={onCancelBack} action="Delete" />
        <ConfirmationPopover onOpen={logConfirmModalOpenSubmit} onConfirm={onConfirmCallBackSubmit} onClose={onCancelBackSubmit} action="Submit" />
        </>
  );
}
export default SelectTransporterStakeholder;
